
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.wrapper{
  display:flex;
  height:350px;
  position:relative;
  max-width:100%;
  -webkit-text-decoration-line:none;
          text-decoration-line:none;
}@media (min-width: 1280px) {.wrapper {
    height: 250px;
  }
}@media (min-width: 1440px) {.wrapper {
    height: 350px;
  }
}

.text-wrapper.centered {
  position: absolute;
  z-index: 40;
  margin-left: 15%;
  margin-right: 15%;
  display: flex;
  height: 100%;
  width: 70%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 2rem;
  text-align: center;
  color: var(--neutral-white);
}

@media (min-width: 768px) {.text-wrapper.centered {
    padding-bottom: 3rem;
  }
}

@media (min-width: 1024px) {.text-wrapper.centered {
    padding-bottom: 4rem;
  }
}

.text-wrapper.centered{
  place-content:center;
}

.text-wrapper.centered .banner-search-forms {
  padding-left: 7%;
  padding-right: 7%;
}

.summary-text {
  display: none;
  color: var(--neutral-white);
}

@media (min-width: 768px) {.summary-text {
    display: block;
  }
}

.gray-overlay {
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color:rgba(0, 0, 0, 0.3);
}

img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  height:auto;
}
`;